import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import "./StoreoffersPage.css";
import storelistCategory from "./../../../assets/product_default.png";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import no_offers from "./../../../assets/no_offers.svg";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { useLocation } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MAGNIFY } from "../../comman/components/CommonimagePath";
import { getRequestcall } from "../../comman/util/getRequest";
import { STORE_OFFER_LIST } from "../../constants/apiurl";
import PaginationPage from "../../comman/components/PaginationPage";
import BannercartPage from "../../comman/components/BannercartPage";

function StoreoffersPage(props) {
  const { t } = useTranslation();
  const { access_token } = props;
  const navigate = useNavigate();
  const [storeOfferList, setStoreOfferlist] = useState();
  const [search, setSearch] = useState("");
  const [nopagination, setNopagination] = useState();
  const location = useLocation();

  useEffect(() => {
    callStoreOfferList();
    // eslint-disable-next-line
  }, [location?.state?.obj, props?.language]);

  const callStoreOfferList = async () => {
    props?.fetchHeaderContent(t("pages.meta.offer.title"),t("pages.meta.offer.description"),"");
    callOfferlist(1, search);
  };

  const callOfferlist = async (page, search) => {
    let url =
      STORE_OFFER_LIST +
      `?page=${page}&lat=${props?.currentLocation?.lat}&lng=${
        props?.currentLocation?.lng
      }&search=${search}&lang=${props.language.toLowerCase()}`;
    let responceList = await getRequestcall(url, access_token);
    if (responceList?.status === 200) {
      let resultList = await responceList?.json();
      if (resultList?.data?.data?.length > 0) {
        setStoreOfferlist(resultList?.data);
        setNopagination(false);
      } else {
        setNopagination(true);
      }
    }
  };

  const onChangeOfferPagination = async (page) => {
    await callOfferlist(page, search);
  };

  const callSearchlist = (search) => {
    setSearch(search);
    callOfferlist(1, search);
  };

  return (
    <>
      <aside className="store_offers">
       <BannercartPage title={"pages.offers.title"}/>
        <Container fluid="lg" className="offers_container container-lg">
          <div className="mb-4 d-flex justify-content-end align-items-center">
            <div className="input-group w-auto">
              <span className="input-group-text">
                <label htmlFor="search">
                  <img
                    src={MAGNIFY}
                    className="magnify"
                    alt="search"
                    height="22"
                    width="22"
                  ></img>
                </label>
              </span>
              <input
                id="search"
                name={"search"}
                value={search}
                onChange={(e) => callSearchlist(e?.target?.value)}
                className="form-control radius-right-round border-left-0 pl-2"
                placeholder={t("pages.offers.search_place")}
              />
            </div>
          </div>
          <Row className="row offer_store_list">
            {storeOfferList?.data?.length > 0 ? (
              storeOfferList?.data?.map((item, index) => (
                <div
                  key={index.toString()}
                  onClick={() => navigate(`/detail/${item?.store_id}`)}
                  className="col-md-6 mb-4"
                >
                  <div className="card">
                    <div className={"offer_store"}>
                      {item?.type === "percentage"
                        ? `${t("pages.offers.flat")} ${item?.percentage}% ${t(
                            "pages.offers.off"
                          )}`
                        : `${t("pages.offers.flat")} ${item?.flat_discount}${
                            process.env.REACT_APP_CURRENCY_SYMBOL
                          } ${t("pages.offers.off")}`}
                    </div>
                    <div className="card-body p-3 d-flex justify-content-start align-items-start">
                      <div className="image_div mt-2">
                        <LazyLoadImage
                          alt=""
                          className="offers_image mt-1"
                          onError={(e) => {
                            e.target.src = storelistCategory;
                          }}
                          src={
                            item?.store?.store_img_url
                              ? item?.store?.store_img_url
                              : storelistCategory
                          }
                        ></LazyLoadImage>
                      </div>
                      <div className="d-block ">
                        <h5 className="font-17 store-title">
                          {item?.store?.title}
                        </h5>
                        <h5 className="font-16">
                          {props?.language === "Tr"
                            ? item?.title_in_tr
                            : item?.title}
                        </h5>
                        <p className="font-14 text-muted-1">
                          {props?.language === "Tr"
                            ? item?.description_in_tr
                            : item?.description}
                        </p>
                        <p className="font-12 mb-0 text-capitlize">
                          {item?.type === "percentage"
                            ? `${t("pages.offers.flat")} ${
                                item?.percentage
                              }% off`
                            : `${t("pages.offers.flat")} ${
                                item?.flat_discount
                              }${process.env.REACT_APP_CURRENCY_SYMBOL} ${t(
                                "pages.offers.off"
                              )}`}{" "}
                          {t("pages.offers.minimum")} {item?.min_order_amount}
                          {process.env.REACT_APP_CURRENCY_SYMBOL}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div id={"no_data_found"}>
                <LazyLoadImage src={no_offers} alt={""} />
                <h5>{t("pages.offers.nooffers")}</h5>
                <p>{t("pages.offers.nooffers_desc")}</p>
              </div>
            )}
          </Row>
          <div className="text-end">
            {!nopagination && storeOfferList?.total > 10 && (
              <PaginationPage
                changeCurrentpage={onChangeOfferPagination}
                nopagination={nopagination}
                links={storeOfferList?.links}
              />
            )}
          </div>
        </Container>
      </aside>
    </>
  );
}
const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  store_id: state?.dashboard?.storeDetail?.store_id,
  language: state?.languageState?.language,
  currentLocation: state?.home?.currentLocation,
});

export default connect(mapStateToProps, { fetchHeaderContent })(
  StoreoffersPage
);
